 export { EventCapturedsService } from './EventCaptured.service'; 
 export { EventConfigsService } from './EventConfig.service'; 
 export { RecordsService } from './Record.service'; 
 export { BqRecordsService } from './BqRecord.service'; 
 export { TriggersService } from './Trigger.service'; 
 export { scoringRecordsService } from './scoringRecord.service'; 
